
document.addEventListener("DOMContentLoaded", function () {
    function removeCommasFromPrices(selector) {
        document.querySelectorAll(selector).forEach(priceElement => {
            if (priceElement) {
                priceElement.textContent = priceElement.textContent.replace(/,/g, ""); // Remove all commas
                priceElement.style.visibility = "visible"; // Ensure visibility
                priceElement.style.opacity = "1";
            }
        });
    }


    function updateProductPagePrices() {
        setTimeout(() => {
            removeCommasFromPrices(".prd-block_price--old .money, .prd-block_price--actual .money");
        }, 10);
    }


    function updateCartDrawerPrices() {
        const cartDrawer = document.querySelector("#dropdnMinicart");
        if (cartDrawer && cartDrawer.classList.contains("is-opened")) {
            removeCommasFromPrices(".minicart-prd-price .price-new .money, .minicart-drop-total-price .money");
        }
    }


    updateProductPagePrices();
    removeCommasFromPrices(".money");


    document.querySelectorAll(".single-option-selector-product-template").forEach(selector => {
        selector.addEventListener("change", updateProductPagePrices);
    });


    document.querySelectorAll(".uatc").forEach(button => {
        button.addEventListener("click", function () {
            setTimeout(updateCartDrawerPrices, 500);
        });
    });

    const cartDrawer = document.querySelector("#dropdnMinicart");
    if (cartDrawer) {
        new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === "class") {
                    updateCartDrawerPrices();
                }
            });
        }).observe(cartDrawer, { attributes: true });
    }
});










